export default "__VITE_ASSET__5176c485__"